// extracted by mini-css-extract-plugin
export default {"bannerAuto":"auth_bannerAuto__5R0ls","blocoDados":"auth_blocoDados__Cxvfe"};